export const PC_COMPONENT_FIELDS = [
  { key: "cpu", label: "Processeur" },
  { key: "gpu", label: "Carte graphique" },
  { key: "ram", label: "RAM" },
  { key: "storage", label: "Stockage principal" },
  { key: "motherboard", label: "Carte mere" },
  { key: "cooling", label: "Refroidissement" },
  { key: "powerSupply", label: "Alimentation" },
];

export const PC_COMPONENT_OPTIONS = {
  cpu: [
    "Intel Core i3-12100F",
    "Intel Core i3-13100F",
    "Intel Core i3-14100F",
    "Intel Core i5-12400F",
    "Intel Core i5-12600K",
    "Intel Core i5-13400F",
    "Intel Core i5-13600K",
    "Intel Core i5-14400F",
    "Intel Core i5-14600K",
    "Intel Core i7-12700K",
    "Intel Core i7-13700K",
    "Intel Core i7-14700K",
    "Intel Core i9-12900K",
    "Intel Core i9-13900K",
    "Intel Core i9-14900K",
    "Intel Core Ultra 5 225",
    "Intel Core Ultra 5 245K",
    "Intel Core Ultra 7 265K",
    "Intel Core Ultra 9 285K",
    "Intel Core Ultra 5 125H",
    "Intel Core Ultra 7 155H",
    "Intel Core Ultra 9 185H",
    "Intel Core Ultra 7 255H",
    "Intel Core Ultra 9 285H",
    "Intel Core Ultra 9 285HX",
    "AMD Ryzen 5 3600",
    "AMD Ryzen 5 5600",
    "AMD Ryzen 5 5600X",
    "AMD Ryzen 7 5700X",
    "AMD Ryzen 7 5800X",
    "AMD Ryzen 7 5800X3D",
    "AMD Ryzen 9 5900X",
    "AMD Ryzen 9 5950X",
    "AMD Ryzen 5 7600",
    "AMD Ryzen 5 7600X",
    "AMD Ryzen 7 7700",
    "AMD Ryzen 7 7700X",
    "AMD Ryzen 7 7800X3D",
    "AMD Ryzen 9 7900",
    "AMD Ryzen 9 7900X",
    "AMD Ryzen 9 7950X",
    "AMD Ryzen 9 7950X3D",
    "AMD Ryzen 5 9600X",
    "AMD Ryzen 7 9700X",
    "AMD Ryzen 7 9800X3D",
    "AMD Ryzen 9 9900X",
    "AMD Ryzen 9 9900X3D",
    "AMD Ryzen 9 9950X",
    "AMD Ryzen 9 9950X3D",
    "AMD Ryzen 7 7840HS",
    "AMD Ryzen 9 7940HS",
    "AMD Ryzen 7 8845HS",
    "AMD Ryzen 9 8945HS",
    "AMD Ryzen AI 9 HX 365",
    "AMD Ryzen AI 9 HX 370",
  ],
  gpu: [
    "NVIDIA GeForce GTX 1060",
    "NVIDIA GeForce GTX 1070",
    "NVIDIA GeForce GTX 1080 Ti",
    "NVIDIA GeForce GTX 1650",
    "NVIDIA GeForce GTX 1660 Super",
    "NVIDIA GeForce RTX 2060",
    "NVIDIA GeForce RTX 2070 Super",
    "NVIDIA GeForce RTX 2080 Ti",
    "NVIDIA GeForce RTX 3060",
    "NVIDIA GeForce RTX 3060 Ti",
    "NVIDIA GeForce RTX 3070",
    "NVIDIA GeForce RTX 3070 Ti",
    "NVIDIA GeForce RTX 3080",
    "NVIDIA GeForce RTX 3080 Ti",
    "NVIDIA GeForce RTX 3090",
    "NVIDIA GeForce RTX 3090 Ti",
    "NVIDIA GeForce RTX 4060",
    "NVIDIA GeForce RTX 4060 Ti",
    "NVIDIA GeForce RTX 4070",
    "NVIDIA GeForce RTX 4070 Super",
    "NVIDIA GeForce RTX 4070 Ti",
    "NVIDIA GeForce RTX 4070 Ti Super",
    "NVIDIA GeForce RTX 4080",
    "NVIDIA GeForce RTX 4080 Super",
    "NVIDIA GeForce RTX 4090",
    "NVIDIA GeForce RTX 5050",
    "NVIDIA GeForce RTX 5060",
    "NVIDIA GeForce RTX 5060 Ti",
    "NVIDIA GeForce RTX 5070",
    "NVIDIA GeForce RTX 5070 Ti",
    "NVIDIA GeForce RTX 5080",
    "NVIDIA GeForce RTX 5090",
    "NVIDIA GeForce RTX 4050 Laptop",
    "NVIDIA GeForce RTX 4060 Laptop",
    "NVIDIA GeForce RTX 4070 Laptop",
    "NVIDIA GeForce RTX 4080 Laptop",
    "NVIDIA GeForce RTX 4090 Laptop",
    "NVIDIA GeForce RTX 5060 Laptop",
    "NVIDIA GeForce RTX 5070 Laptop",
    "NVIDIA GeForce RTX 5080 Laptop",
    "NVIDIA GeForce RTX 5090 Laptop",
    "AMD Radeon RX 580",
    "AMD Radeon RX 5600 XT",
    "AMD Radeon RX 5700 XT",
    "AMD Radeon RX 6600",
    "AMD Radeon RX 6650 XT",
    "AMD Radeon RX 6700 XT",
    "AMD Radeon RX 6750 XT",
    "AMD Radeon RX 6800",
    "AMD Radeon RX 6800 XT",
    "AMD Radeon RX 6900 XT",
    "AMD Radeon RX 6950 XT",
    "AMD Radeon RX 7600",
    "AMD Radeon RX 7600 XT",
    "AMD Radeon RX 7700 XT",
    "AMD Radeon RX 7800 XT",
    "AMD Radeon RX 7900 GRE",
    "AMD Radeon RX 7900 XT",
    "AMD Radeon RX 7900 XTX",
    "AMD Radeon RX 9060 XT",
    "AMD Radeon RX 9070",
    "AMD Radeon RX 9070 XT",
    "AMD Radeon 760M",
    "AMD Radeon 780M",
    "AMD Radeon 880M",
    "AMD Radeon 890M",
    "Intel Arc A380",
    "Intel Arc A580",
    "Intel Arc A750",
    "Intel Arc A770",
    "Intel Arc B570",
    "Intel Arc B580",
  ],
  ram: [
    "8 Go DDR4",
    "16 Go DDR4",
    "32 Go DDR4",
    "64 Go DDR4",
    "128 Go DDR4",
    "16 Go DDR5",
    "24 Go DDR5",
    "32 Go DDR5",
    "48 Go DDR5",
    "64 Go DDR5",
    "96 Go DDR5",
    "128 Go DDR5",
    "16 Go LPDDR5",
    "24 Go LPDDR5",
    "32 Go LPDDR5",
    "64 Go LPDDR5",
    "16 Go LPDDR5X",
    "24 Go LPDDR5X",
    "32 Go LPDDR5X",
    "64 Go LPDDR5X",
  ],
  storage: [
    "SSD SATA 250 Go",
    "SSD SATA 500 Go",
    "SSD SATA 1 To",
    "SSD SATA 2 To",
    "SSD NVMe 500 Go",
    "SSD NVMe 1 To",
    "SSD NVMe 2 To",
    "SSD NVMe 4 To",
    "SSD NVMe 8 To",
    "SSD NVMe Gen4 1 To",
    "SSD NVMe Gen4 2 To",
    "SSD NVMe Gen4 4 To",
    "SSD NVMe Gen5 1 To",
    "SSD NVMe Gen5 2 To",
    "SSD NVMe Gen5 4 To",
    "HDD 1 To",
    "HDD 2 To",
    "HDD 4 To",
    "HDD 8 To",
  ],
  motherboard: [
    "Intel H610",
    "Intel B660",
    "Intel B760",
    "Intel Z690",
    "Intel Z790",
    "Intel B860",
    "Intel Z890",
    "AMD A520",
    "AMD B450",
    "AMD B550",
    "AMD X570",
    "AMD A620",
    "AMD B650",
    "AMD B650E",
    "AMD X670",
    "AMD X670E",
    "AMD B850",
    "AMD X870",
    "AMD X870E",
    "Carte mere laptop proprietaire",
    "Carte mere mini-PC proprietaire",
  ],
  cooling: [
    "Ventirad stock",
    "Ventirad compact",
    "Ventirad tour",
    "Ventirad double tour",
    "Watercooling AIO 120 mm",
    "Watercooling AIO 240 mm",
    "Watercooling AIO 280 mm",
    "Watercooling AIO 360 mm",
    "Watercooling AIO 420 mm",
    "Refroidissement laptop",
    "Refroidissement mini-PC",
    "Refroidissement custom loop",
  ],
  powerSupply: [
    "450 W Bronze",
    "500 W Bronze",
    "550 W Bronze",
    "650 W Bronze",
    "650 W Gold",
    "750 W Gold",
    "850 W Gold",
    "1000 W Gold",
    "1200 W Platinum",
    "1600 W Platinum",
    "SFX 650 W Gold",
    "SFX 750 W Platinum",
    "SFX-L 850 W Platinum",
    "Chargeur laptop 100 W USB-C",
    "Chargeur laptop 140 W USB-C",
    "Chargeur laptop 180 W",
    "Chargeur laptop 240 W",
    "Chargeur laptop 280 W",
    "Chargeur laptop 330 W",
  ],
};

export function getPcComponentOptions(key) {
  return [
    { id: "", label: "Non precise" },
    ...(PC_COMPONENT_OPTIONS[key] || []).map((model) => ({
      id: model,
      label: model,
    })),
  ];
}
